import type { CSSProperties } from 'react';
import type { ResponsiveProperty } from './responsive';
import { lengthValue, resolveResponsive } from './responsive';

export type SpacingType =
  | 0
  | 4
  | 8
  | 12
  | 16
  | 24
  | 32
  | 40
  | 64
  | 80
  | 120
  | 160
  | 240;
export type AutoType = 'auto';
export type MaxWidthType =
  | 240
  | 320
  | 400
  | 480
  | 560
  | 640
  | 680
  | 720
  | 800
  | 960
  | 1200;

export type MarginType = ResponsiveProperty<
  | SpacingType
  | AutoType
  | -4
  | -8
  | -12
  | -16
  | -24
  | -32
  | -40
  | -64
  | -80
  | -120
  | -160
  | -240
>;

export type PaddingType = ResponsiveProperty<SpacingType | AutoType>;

export interface DisplayProps {
  display?: ResponsiveProperty<CSSProperties['display']>;
}

export interface MarginProps {
  margin?: MarginType;
  marginTop?: MarginType;
  marginRight?: MarginType;
  marginBottom?: MarginType;
  marginLeft?: MarginType;
}

export interface PaddingProps {
  padding?: PaddingType;
  paddingTop?: PaddingType;
  paddingRight?: PaddingType;
  paddingBottom?: PaddingType;
  paddingLeft?: PaddingType;
}

export interface MaxWidthProps {
  maxWidth?: MaxWidthType | AutoType;
}

export const spacingStyle = (
  props: MarginProps & PaddingProps & MaxWidthProps
): CSSProperties => ({
  marginTop: lengthValue(resolveResponsive(props.marginTop ?? props.margin)),
  marginRight: lengthValue(
    resolveResponsive(props.marginRight ?? props.margin)
  ),
  marginBottom: lengthValue(
    resolveResponsive(props.marginBottom ?? props.margin)
  ),
  marginLeft: lengthValue(resolveResponsive(props.marginLeft ?? props.margin)),
  paddingTop: lengthValue(resolveResponsive(props.paddingTop ?? props.padding)),
  paddingRight: lengthValue(
    resolveResponsive(props.paddingRight ?? props.padding)
  ),
  paddingBottom: lengthValue(
    resolveResponsive(props.paddingBottom ?? props.padding)
  ),
  paddingLeft: lengthValue(
    resolveResponsive(props.paddingLeft ?? props.padding)
  ),
  maxWidth: lengthValue(props.maxWidth),
});
